export default "__VITE_ASSET__D3Djdi_z__"